import { consoleApiSlice } from "./consoleApiSlice";

export const consoleScopeTrackerApiSlice = consoleApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getScopeTrackerWebsites: builder.query({
      query: () => ({
        url: "/scope-selection-tracker/websites",
      }),
      providesTags: ["ScopeTrackerWebsites"],
    }),
    updateDisplayScopeSelection: builder.mutation({
      query: ({ websiteId, displayScopeSelection, useProd = false }) => ({
        url: `/scope-selection-tracker/websites/${websiteId}/display-scope-selection`,
        method: "PATCH",
        body: { display_scope_selection: displayScopeSelection },
        params: { use_prod: useProd },
      }),
      async onQueryStarted({ websiteUrl, displayScopeSelection, useProd }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          consoleScopeTrackerApiSlice.util.updateQueryData("getScopeTrackerWebsites", undefined, (draft) => {
            const website = draft.find((w) => w.website_url === websiteUrl);
            if (website) {
              if (useProd) {
                website.prod_display_scope = displayScopeSelection;
              } else {
                website.staging_display_scope = displayScopeSelection;
              }
            }
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
      invalidatesTags: ["ScopeTrackerWebsites"],
    }),
    getScopeStatus: builder.query({
      query: (websiteId) => ({
        url: `/scope-selection-tracker/websites/${websiteId}/scope-status`,
      }),
      providesTags: (result, error, websiteId) => [{ type: "ScopeStatus", id: websiteId }],
    }),
    refreshScopeSelection: builder.mutation({
      query: ({ websiteId, localeCode }) => ({
        url: `/scope-selection-tracker/websites/${websiteId}/refresh-scope`,
        method: "POST",
        body: localeCode ? { locale_code: localeCode } : {},
      }),
      async onQueryStarted({ websiteId }, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          consoleScopeTrackerApiSlice.util.updateQueryData("getScopeTrackerWebsites", undefined, (draft) => {
            const website = draft.find((w) => w.staging_website_id === websiteId);
            if (website) {
              website.scope_status = "running";
            }
          })
        );
        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
      invalidatesTags: (result, error, { websiteId }) => [
        "ScopeTrackerWebsites",
        { type: "ScopeStatus", id: websiteId },
      ],
    }),
  }),
});

export const {
  useGetScopeTrackerWebsitesQuery,
  useUpdateDisplayScopeSelectionMutation,
  useGetScopeStatusQuery,
  useRefreshScopeSelectionMutation,
} = consoleScopeTrackerApiSlice;
